<template>
  <div 
    class="tag-reference"
    :class="`tag-reference--tail-${tailPosition}`"
    :style="styles"
    ref="el"
    v-html="label"
  >
  </div>
</template>
<script>
export default {
  props: [ 'pos', 'label', 'tail-position'],
  data () {
    return {
      offsetX: 0,
      offsetY: 0
    }
  },

  computed: {
    styles () {
      return {
        // divide by font size
        left: `${(this.pos.x / 20) / 1.4}em`,
        top: `${(this.pos.y / 20) / 1.4}em`,
      }
    }
  },
}
</script>
<style lang="scss">
@import "@/styles/_variables.scss";
@import "@/styles/_mixins.scss";


.tag-reference {
  align-items: center;
  background-color: $reference-tag-bg-color;
  border-radius: 50%;
  box-shadow: $tag-box-shadow;
  color: $reference-tag-font-color;
  display: flex;
  font-family: $reference-tag-font-family;
  font-size: $reference-tag-font-size;
  font-weight: 600;
  height: 2.5em;
  justify-content: center;
  line-height: normal;
  position: absolute;
  width: 2.5em;
  z-index: 9;

  * {
    pointer-events: none;
    user-select: none;
  }

  &--tail-top-center:after {
    margin-bottom: calc(-0.4rem / 1.4);
    @include tail(top, center, $reference-tag-bg-color, calc(1rem / 1.4))
  }  

  &--tail-bottom-center:after {
    margin-top: calc(-0.4rem / 1.4);
    @include tail(bottom, center, $reference-tag-bg-color, calc(1rem / 1.4))
  }

  &--tail-left-center:after {
    margin-right: calc(-0.4rem / 1.4);
    @include tail(left, center, $reference-tag-bg-color, calc(1rem / 1.4))
  }  

  &--tail-right-center:after {
    margin-left: calc(-0.4rem / 1.4);
    @include tail(right, center, $reference-tag-bg-color, calc(1rem / 1.4))
  }    
}
</style>
